import { Labels } from '../../shared-components/global/labels.js';

Labels.set('ui-dropdown', 'close', 'Uždaryti iššokantį langą');
Labels.set('ui-dropdown', 'closeLang', 'Uždaryti kalbos pasirinkimą');
Labels.set('ui-dropdown', 'openLang', 'Atidaryti kalbos pasirinkimą');
Labels.set('ui-dropdown', 'countryCode', 'Šalies kodas');

Labels.set('ui-dropdown', 'eng', 'Anglų');
Labels.set('ui-dropdown', 'est', 'Lietuvių');
Labels.set('ui-dropdown', 'lit', 'Rusų');
